import * as types from '../actions/types';
import mapKeys from 'lodash/mapKeys';

const INITIAL_STATE = {
  bookingOrders: [],
  invitedBookingOrders: [],
  bookingOrdersFiltered: [],
  onProgress: '',
  predefinedPendingReasons: [],
  predefinedAcceptedReasons: [],
  predefinedRunningReasons: [],
  orderDetails: {},
  sessionHours: {},
  completed: '',
  showHeader: true,
  onlineSessionHours: '',
  promoCode: {
    isValid: false,
    percentage: '',
    discountCode: '',
    amount: 0,
  },
  isSubmittedPromoCode: false,
  stepper: {
    totalPrice: '',
    activeStep: '',
    firstStepData: '',
    secondStepData: '',
    thirdStepData: '',
    numOfStudents: '',
  },
  error: {
    type: '',
    message: '',
  },
  mainSessionDetails: null,
};

const orderReducer = (state = INITIAL_STATE, { payload, type, error }) => {
  // store cities used in signup
  switch (type) {
    case 'TOGGLE_HEADER':
      return {
        ...state,
        showHeader: payload,
      };
    case types.GET_ORDER_DETAILS_REQUEST:
      return {
        ...state,
        onProgress: 'GET_ORDER_DETAILS',
        completed: '',
        error: {
          type: '',
          message: '',
        },
      };

    case types.GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        onProgress: '',
        orderDetails: payload,
        completed: 'GET_ORDER_DETAILS',
      };

    case types.GET_ORDER_DETAILS_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'GET_ORDER_DETAILS',
          message: error,
        },
        completed: '',
      };

    case types.GET_PREDEFINED_CANCEL_BOOKING_REASONS_REQUEST:
      return {
        ...state,
        error: {
          type: '',
          message: '',
        },
      };

    case types.GET_PREDEFINED_CANCEL_BOOKING_REASONS_SUCCESS:
      return {
        ...state,
        onProgress: '',
        predefinedPendingReasons: payload.pendingReasons,
        predefinedAcceptedReasons: payload.acceptedReasons,
        predefinedRunningReasons: payload.runningReasons,
      };

    case types.GET_PREDEFINED_CANCEL_BOOKING_REASONS_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'GET_PREDEFINED_REASONS',
          message: error,
        },
        completed: '',
      };

    case types.BOOK_TUTOR_REQUEST:
      return {
        ...state,
        onProgress: 'BOOK_TUTOR',
        completed: '',
        error: {
          type: '',
          message: '',
        },
      };

    case types.BOOK_TUTOR_SUCCESS:
      return {
        ...state,
        onProgress: '',
        stepper: {},
        error: {
          type: '',
          message: '',
        },
        completed: 'BOOK_TUTOR',
      };

    case types.BOOK_TUTOR_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'BOOK_TUTOR',
          message: error,
        },
        completed: '',
      };

    case types.APPLY_DISCOUNT_CODE_REQUEST:
      return {
        ...state,
        onProgress: 'APPLY_DISCOUNT_CODE',
        completed: '',
        isSubmittedPromoCode: false,
        error: {
          type: '',
          message: '',
        },
      };

    case types.APPLY_DISCOUNT_CODE_SUCCESS:
      return {
        ...state,
        onProgress: '',
        isSubmittedPromoCode: true,
        error: {
          type: '',
          message: '',
        },
        promoCode: payload,
        completed: 'APPLY_DISCOUNT_CODE',
      };

    case types.APPLY_DISCOUNT_CODE_FAIL:
      return {
        ...state,
        onProgress: '',
        isSubmittedPromoCode: true,
        promoCode: {
          isValid: false,
          percentage: '',
          discountCode: '',
          amount: 0,
        },
        error: {
          type: 'APPLY_DISCOUNT_CODE',
          message: error,
        },
        completed: '',
      };

    case types.RESET_SUBMIT_DISCOUNT_CODE:
      return {
        ...state,
        isSubmittedPromoCode: false,
      };

    case types.START_SESSION_REQUEST:
      return {
        ...state,
        onProgress: 'START_SESSION',
        completed: '',
        error: {
          type: '',
          message: '',
        },
      };

    case types.START_SESSION_SUCCESS:
      return {
        ...state,
        onProgress: '',
        error: {
          type: '',
          message: '',
        },
        completed: 'START_SESSION',
        sessionDetails: payload,
      };
    case types.OPEN_SESSION_SUCCESS:
      return {
        ...state,
        onProgress: '',
        error: {
          type: '',
          message: '',
        },
        completed: 'START_SESSION',
        sessionDetails: payload,
      };
    case types.START_SESSION_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'START_SESSION',
          message: error,
        },
        completed: '',
      };

    case types.GET_BOOKING_ORDERS_REQUEST: {
      return {
        ...state,
        onProgress: 'GET_BOOKING_ORDERS',
        completed: '',
      };
    }

    case types.GET_BOOKING_ORDERS_SUCCESS:
      return {
        ...state,
        bookingOrders: payload.bookingOrders,
        has_demo: payload.has_demo,
        onProgress: '',
        completed: 'GET_BOOKING_ORDERS',
      };

    case types.GET_BOOKING_ORDERS_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'GET_BOOKING_ORDERS',
          message: error,
        },
      };

    case types.GET_INVITED_BOOKING_ORDERS_SUCCESS:
      return {
        ...state,
        invitedBookingOrders: payload,
        onProgress: '',
      };

    case types.GET_SESSION_HOURS_REQUEST:
      return {
        ...state,
        onProgress: 'GET_SESSION_HOURS',
      };

    case types.GET_SESSION_HOURS_SUCCESS:
      return {
        ...state,
        sessionHours: payload,
        onProgress: '',
      };

    case types.GET_SESSION_HOURS_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {},
      };

    case types.END_ONLINE_SESSION_SUCCESS:
      return {
        ...state,
        onlineSessionHours: payload?.classDuration,
        sl_id: payload?.sl_id,
        completed: 'END_ONLINE_SESSION',
      };

    case types.FILTER_BOOKING_ORDERS_REQUEST:
      return {
        ...state,
        onProgress: 'FILTER_BOOKING_ORDERS',
      };

    case types.FILTER_BOOKING_ORDERS_SUCCESS:
      return {
        ...state,
        bookingOrdersFiltered: payload,
        onProgress: '',
      };

    case types.FILTER_BOOKING_ORDERS_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'FILTER_BOOKING_ORDERS',
          message: error,
        },
      };

    case types.CANCEL_BOOKING_BY_TUTOR_REQUEST:
      return {
        ...state,
        onProgress: `CANCEL_BOOKING_${payload}`,
        completed: '',
      };

    case types.CANCEL_BOOKING_BY_TUTOR_SUCCESS: {
      const bookingOrders = state.bookingOrders.filter(
        (order) => order.booking_id !== payload.booking_id
      );
      return {
        ...state,
        onProgress: '',
        completed: `CANCEL_BOOKING`,
        bookingOrders,
      };
    }

    case types.CANCEL_BOOKING_BY_TUTOR_FAIL: {
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'CANCEL_BOOKING',
          message: error,
        },
      };
    }
    case types.CHANGE_BOOKING_STATUS_REQUEST:
      return {
        ...state,
        onProgress: `CHANGE_STATUS_${payload}`,
        completed: '',
      };

    case types.CHANGE_BOOKING_STATUS_SUCCESS: {
      return {
        ...state,
        onProgress: '',
        completed: `CHANGE_STATUS`,
      };
    }

    case types.CHANGE_BOOKING_STATUS_FAIL: {
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'CHANGE_STATUS',
          message: error,
        },
      };
    }

    case types.RATE_SESSION_REQUEST:
      return {
        ...state,
        onProgress: `RATE_SESSION_${payload.booking_id}`,
        completed: '',
      };

    case types.RATE_SESSION_SUCCESS: {
      const bookingOrders = mapKeys(state.bookingOrders, 'id');
      const updatedBooking = {
        ...bookingOrders[payload.booking_id],
        status: 'closed',
      };
      bookingOrders[payload.booking_id] = updatedBooking;
      const data = Object.values(bookingOrders).reverse();

      return {
        ...state,
        onProgress: '',
        completed: `RATE_SESSION`,
        bookingOrders: data,
      };
    }

    case types.RATE_SESSION_FAIL: {
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'RATE_SESSION',
          message: error,
        },
      };
    }

    case types.CANCEL_BOOKING_BY_STUDENT_REQUEST:
      return {
        ...state,
        onProgress: `CANCEL_BOOKING_${payload}`,
        completed: '',
      };

    case types.CANCEL_BOOKING_BY_STUDENT_SUCCESS: {
      let bookingOrdersAsObj = mapKeys(state.bookingOrders, 'id');
      const order = (bookingOrdersAsObj[payload.booking_id] = {
        ...bookingOrdersAsObj[payload.booking_id],
        status: payload.isSessionStarted
          ? 'cancelled_after_course_completed'
          : 'cancelled_before_course_started',
      });

      bookingOrdersAsObj = {
        ...bookingOrdersAsObj,
        [payload.booking_id]: order,
      };

      return {
        ...state,
        onProgress: '',
        completed: `CANCEL_BOOKING`,
        bookingOrders: Object.values(bookingOrdersAsObj),
      };
    }

    case types.CANCEL_BOOKING_BY_STUDENT_FAIL: {
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'CANCEL_BOOKING',
          message: error,
        },
      };
    }

    case types.ACCEPT_BOOKING_REQUEST:
      return {
        ...state,
        onProgress: `ACCEPT_BOOKING_${payload}`,
        completed: '',
      };

    case types.ACCEPT_BOOKING_SUCCESS: {
      const bookingOrders = mapKeys(state.bookingOrders, 'id');
      const updatedBooking = { ...bookingOrders[payload], status: 'approved' };
      bookingOrders[payload] = updatedBooking;
      const data = Object.values(bookingOrders).reverse();

      return {
        ...state,
        onProgress: '',
        completed: `ACCEPT_BOOKING`,
        bookingOrders: data,
      };
    }

    case types.ACCEPT_BOOKING_FAIL:
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'ACCEPT_BOOKING',
          message: error,
        },
      };

    case types.COMPLETE_BOOKING_REQUEST:
      return {
        ...state,
        onProgress: `COMPLETE_BOOKING`,
        completed: '',
      };

    case types.COMPLETE_BOOKING_SUCCESS: {
      const bookingOrders = mapKeys(state.bookingOrders, 'id');

      const updatedBooking = {
        ...bookingOrders[payload.booking_id],
        status: 'completed',
      };

      bookingOrders[payload.booking_id] = updatedBooking;
      const data = Object.values(bookingOrders).reverse();

      return {
        ...state,
        onProgress: '',
        completed: `COMPLETE_BOOKING`,
        bookingOrders: data,
      };
    }

    case types.COMPLETE_BOOKING_FAIL:
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'COMPLETE_BOOKING',
          message: error,
        },
      };

    case types.UPDATE_BOOKING_REQUEST:
      return {
        ...state,
        onProgress: `UPDATE_BOOKING`,
        completed: '',
      };

    case types.UPDATE_BOOKING_SUCCESS: {
      const bookingOrders = mapKeys(state.bookingOrders, 'id');
      const updatedBooking = {
        ...bookingOrders[payload.booking_id],
        ...payload,
      };
      bookingOrders[payload.booking_id] = updatedBooking;
      const data = Object.values(bookingOrders).reverse();

      return {
        ...state,
        onProgress: '',
        completed: `UPDATE_BOOKING`,
        bookingOrders: data,
      };
    }

    case types.UPDATE_BOOKING_FAIL:
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'UPDATE_BOOKING',
          message: error,
        },
      };

    case types.SET_STEPPER_DATA:
      return {
        ...state,
        stepper: payload,
      };

    case types.CLEAR_MESSAGES:
      return {
        ...state,
        error: INITIAL_STATE.error,
        onProgress: INITIAL_STATE.onProgress,
        completed: INITIAL_STATE.completed,
      };

    default:
      return { ...state };
  }
};

export default orderReducer;
